import { getFeature } from 'Cloud/Application/FeaturesEs6';

// CLOUDWEB-18463
// Экран блокировки файлов (замена шага очистки)
export const overquotaNewFullBlocked: boolean | undefined = getFeature('overquota-full-blocked');
export const overquotaNewFullBlockedModal: boolean | undefined = getFeature('overquota-full-blocked-modal');
export const overquotaNewModalMoreInfoUrl: string =
    getFeature('overquota-new-modal-more-info-url') || 'https://help.mail.ru/legal/terms/cloud/LA';
